import { isEmpty } from 'lodash-es';
import { JobServeSkill } from 'wisestep-api';
import { IFilterList } from 'wisestep-base';

import IJobServeAdvanceSearch from '../types/IJobServeAdvanceSearch';

export const pushSearchFilters = (data: IJobServeAdvanceSearch) => {
  const filtersArray: IFilterList[] = [];
  if (!isEmpty(data.locationTypes))
    filtersArray.push({
      tag: `Location Types: ${data.locationTypes.join(',')}`,
      id: 'locationTypes',
    });
  if (!isEmpty(data.industry))
    filtersArray.push({
      tag: `Industry: ${data.industry}`,
      id: 'industry',
    });
  if (!isEmpty(data.employmentType))
    filtersArray.push({
      tag: `Employment Type: ${data.employmentType}`,
      id: 'employmentType',
    });
  if (!isEmpty(data.minSalary))
    filtersArray.push({
      tag: `Min Salary: ${data.minSalary}`,
      id: 'minSalary',
    });
  if (!isEmpty(data.maxSalary))
    filtersArray.push({
      tag: `Max Salary: ${data.maxSalary}`,
      id: 'maxSalary',
    });
  if (!isEmpty(data.visaStatus))
    filtersArray.push({
      tag: `Visa Status: ${data.visaStatus}`,
      id: 'visaStatus',
    });
  if (!isEmpty(data.securityClearance))
    filtersArray.push({
      tag: `Security Clearance: ${data.securityClearance.join(',')}`,
      id: 'securityClearance',
    });
  if (!isEmpty(data.minEducation))
    filtersArray.push({
      tag: `Min Education: ${data.minEducation}`,
      id: 'minEducation',
    });
  if (!isEmpty(data.latestJobTitle))
    filtersArray.push({
      tag: `Countries: ${data.latestJobTitle}`,
      id: 'authorizedCountries',
    });
  if (!isEmpty(data.skills))
    filtersArray.push({
      tag: `Skills: ${data.skills
        .map((val: JobServeSkill) => val.skill + ':' + val.experience)
        .join(',')}`,
      id: 'skills',
    });

  return filtersArray;
};
